var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.09,26.51l-2.57-3a5.54,5.54,0,0,0,0-7.35,5.6,5.6,0,1,0-4.62,9.26h.4a5.53,5.53,0,0,0,3.05-.93l2.56,3a.75.75,0,0,0,1.14-1Zm-7-2.57a4,4,0,0,1-2.81-1.4,4.1,4.1,0,1,1,7.19-2.4A4.09,4.09,0,0,1,20,23.94Z",
    fill: "#624de3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search-2.e6bccc0f5be7553b827990c542fd83d2.svg";
export { ForwardRef as ReactComponent };